import { isVisible } from './dom';
import type { PointerContext, PointerField, PointerTrigger } from './types';

const MAX_FIELDS = 16;
const MAX_LABEL_LENGTH = 60;
const MAX_VALUE_LENGTH = 80;
const SENSITIVE_TYPES = ['password', 'email', 'tel', 'hidden'];

function getLabel(input: HTMLInputElement) {
  const labelled =
    input.getAttribute('aria-label') ??
    input.labels?.[0]?.textContent ??
    input.getAttribute('placeholder') ??
    input.name;
  return (labelled ?? '').trim().slice(0, MAX_LABEL_LENGTH);
}

function collectFields(): PointerField[] {
  const inputs = document.querySelectorAll<HTMLInputElement>(
    'input:not([type="hidden"]):not([type="submit"]), textarea, select',
  );
  return Array.from(inputs)
    .filter(isVisible)
    .map((input) => {
      const filled = input.value !== '';
      const isSensitive = SENSITIVE_TYPES.includes(input.type);
      return {
        label: getLabel(input),
        filled,
        value:
          filled && !isSensitive
            ? input.value.slice(0, MAX_VALUE_LENGTH)
            : undefined,
      };
    })
    .filter((field) => field.label)
    .slice(0, MAX_FIELDS);
}

export function collectContext(
  trigger: PointerTrigger,
  detail?: string,
): PointerContext {
  const heading = document.querySelector('h1, h2')?.textContent ?? '';
  return {
    trigger,
    path: window.location.pathname,
    heading: heading.trim().slice(0, 120),
    fields: collectFields(),
    detail,
  };
}
